import React, { useState, useEffect } from 'react'
import './RSVP.css'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import './SaveTheDate.css';
import icon from '../Assets/Icons/saveTheDate.png'
import fdm from '../Assets/fd-logo.png'
import moment from 'moment';
import acceptIcon from '../Assets/Icons/rsvp-accept.png'
import declineIcon from '../Assets/Icons/rsvp-decline.png'
import starsLeft from '../Assets/Icons/stars-left.png'
import starsRight from '../Assets/Icons/stars-right.png'
import heartsLeft from '../Assets/Icons/hearts-left.png'
import heartsRight from '../Assets/Icons/hearts-right.png'
import OTPModal from './OTPModal'
import DeclineModal from './DeclineModal'
import AcceptModal from './AcceptModal'
import RsvpInvitationDetails, { getInviteWording } from './RsvpInvitationDetails'
import WeddingWebsiteCallout from './WeddingWebsiteCallout'
import { showMealChoicesForGuest } from '../utils/rsvpDisplay'

const RSVP = () => {
    const { guestId } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [guestData, setGuestData] = useState(null)
    const [weddingData, setWeddingData] = useState(null)
    const [weddingDate, setWeddingDate] = useState("");
    const [clientName, setClientName] = useState("");
    const [spouse, setSpouse] = useState("");
    const [canAttend, setCanAttend] = useState("");
    const [invitedTo, setInvitedTo] = useState("");
    const [showOTPModal, setShowOTPModal] = useState(true)
    const [otpError, setOtpError] = useState("");
    const [giftRegistryMsg, setGiftRegistryMsg] = useState("Your presence is the greatest gift, but if you'd like to give something, a contribution to our honeymoon fund would mean the world!")
    const [showDeclineModal, setShowDeclineModal] = useState(false)
    const [showAcceptModal, setShowAcceptModal] = useState(false)
    const [isReadOnly, setIsReadOnly] = useState(false)
    const [guestName, setGuestName] = useState("")
    const [guestEmail, setGuestEmail] = useState("")
    const [guestPhone, setGuestPhone] = useState("")
    const [guestDietary, setGuestDietary] = useState("")
    const [guestStarter, setGuestStarter] = useState("")
    const [guestMain, setGuestMain] = useState("")
    const [guestDessert, setGuestDessert] = useState("")
    const [savingInfo, setSavingInfo] = useState(false)
    const [savingMeals, setSavingMeals] = useState(false)
    const [submittingRSVP, setSubmittingRSVP] = useState(false)
    const [plusOnesData, setPlusOnesData] = useState([])
    const [savingPlusOnes, setSavingPlusOnes] = useState(false)

    const requiresMealChoices = showMealChoicesForGuest(invitedTo, weddingData);

    // Check if all required information is complete for submission
    const canSubmit = () => {
        // Must have accepted the invitation
        if (canAttend !== true) return false;

        // Primary guest must have a name; meal choices only for all-day guests
        if (!guestName) return false;
        if (requiresMealChoices && (!guestStarter || !guestMain || !guestDessert)) return false;

        // Check all plus ones have required details
        if (plusOnesData && plusOnesData.length > 0) {
            for (let plusOne of plusOnesData) {
                if (!plusOne.name) return false;
                if (!plusOne.age) return false;

                if (!requiresMealChoices) continue;

                // If it's a baby with no meal needed, skip meal validation
                if (plusOne.age === 'Baby' && plusOne.noMealNeeded) {
                    continue;
                }

                if (!plusOne.starter || !plusOne.main || !plusOne.dessert) {
                    return false;
                }
            }
        }

        return true;
    }

    // Helper function to generate dietary identifiers
    const getDietaryIdentifiers = (meal) => {
        if (!meal) return '';
        const identifiers = [];
        if (meal.vegetarian === true) identifiers.push('(v)');
        if (meal.vegan === true) identifiers.push('(vg)');
        if (meal.glutenFree === true) identifiers.push('(gf)');
        return identifiers.length > 0 ? ` ${identifiers.join('')}` : '';
    }

    const handleAccept = () => {
        if (isReadOnly) return; // Prevent action if read-only
        setShowAcceptModal(true)
    }

    const handleConfirmAccept = () => {
        setCanAttend(true)

        // Update RSVP response on the backend
        axios.post(`${process.env.REACT_APP_API}/weddings/update-rsvp-response`, {
            guestId,
            response: 'Accept'
        })
            .then((res) => {
                console.log('Guest accepted invitation:', res.data)
            })
            .catch((error) => {
                console.error('Error updating RSVP response:', error)
            })

        // Scroll to accept container after modal closes
        setTimeout(() => {
            const acceptContainer = document.getElementById('accept-container')
            if (acceptContainer) {
                acceptContainer.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }, 100)
    }

    const handleDecline = () => {
        if (isReadOnly) return; // Prevent action if read-only
        setShowDeclineModal(true)
    }

    const handleSaveGuestInfo = () => {
        setSavingInfo(true)

        axios.patch(`${process.env.REACT_APP_API}/weddings/update-guest-info`, {
            guestId,
            name: guestName,
            email: guestEmail,
            number: guestPhone
        })
            .then((res) => {
                console.log('Guest info saved:', res.data)
                // Update guestData with the saved info
                setGuestData(res.data.guest)
                setSavingInfo(false)
                alert('Your information has been saved successfully!')
            })
            .catch((error) => {
                console.error('Error saving guest info:', error)
                setSavingInfo(false)
                alert('There was an error saving your information. Please try again.')
            })
    }

    const handleSaveMealChoices = () => {
        setSavingMeals(true)

        // Convert meal IDs or "Skip this course" to the format expected by backend
        // Backend expects meal IDs or "Skip this course"
        const convertToMealId = (val) => {
            if (!val || val === "") return "";
            if (val === "Skip this course") return "Skip this course";
            // If it's already a meal ID, return as is
            // If it's a meal name, find the meal ID
            const allMeals = weddingData?.meals || [];
            const foundMeal = allMeals.find(meal => meal.name === val);
            return foundMeal ? foundMeal._id.toString() : val;
        };

        axios.patch(`${process.env.REACT_APP_API}/weddings/update-guest-meal-choices`, {
            guestId,
            starter: convertToMealId(guestStarter),
            main: convertToMealId(guestMain),
            dessert: convertToMealId(guestDessert),
            dietaryRequirements: guestDietary
        })
            .then((res) => {
                console.log('Meal choices saved:', res.data)
                // Update guestData with the saved info
                setGuestData(res.data.guest)
                setSavingMeals(false)
                alert('Your meal choices have been saved successfully!')
            })
            .catch((error) => {
                console.error('Error saving meal choices:', error)
                setSavingMeals(false)
                alert('There was an error saving your meal choices. Please try again.')
            })
    }

    const handleSubmitRSVP = async () => {
        if (!canSubmit()) {
            alert('Please complete all required information before submitting your RSVP.')
            return
        }

        setSubmittingRSVP(true)

        try {
            // First, save guest info
            await axios.patch(`${process.env.REACT_APP_API}/weddings/update-guest-info`, {
                guestId,
                name: guestName,
                email: guestEmail,
                number: guestPhone
            })

            if (requiresMealChoices) {
                const convertToMealId = (val) => {
                    if (!val || val === "") return "";
                    if (val === "Skip this course") return "Skip this course";
                    const allMeals = weddingData?.meals || [];
                    const foundMeal = allMeals.find(meal => meal.name === val);
                    return foundMeal ? foundMeal._id.toString() : val;
                };

                await axios.patch(`${process.env.REACT_APP_API}/weddings/update-guest-meal-choices`, {
                    guestId,
                    starter: convertToMealId(guestStarter),
                    main: convertToMealId(guestMain),
                    dessert: convertToMealId(guestDessert),
                    dietaryRequirements: guestDietary
                })
            }

            if (plusOnesData && plusOnesData.length > 0) {
                const convertToMealId = (val) => {
                    if (!val || val === "") return "";
                    if (val === "Skip this course") return "Skip this course";
                    const allMeals = weddingData?.meals || [];
                    const foundMeal = allMeals.find(meal => meal.name === val);
                    return foundMeal ? foundMeal._id.toString() : val;
                };

                await axios.patch(`${process.env.REACT_APP_API}/weddings/update-plus-ones`, {
                    guestId,
                    plusOnes: plusOnesData.map(plusOne => {
                        const base = {
                            name: plusOne.name,
                            age: plusOne.age,
                            needsHighChair: plusOne.needsHighChair || false,
                        };

                        if (!requiresMealChoices) {
                            return base;
                        }

                        return {
                            ...base,
                            mealChoices: {
                                starter: convertToMealId(plusOne.starter),
                                main: convertToMealId(plusOne.main),
                                dessert: convertToMealId(plusOne.dessert)
                            },
                            dietaryRequirements: plusOne.dietaryRequirements,
                            noMealNeeded: plusOne.noMealNeeded || false,
                        };
                    })
                })
            }

            // Finally, mark RSVP as complete
            const response = await axios.post(`${process.env.REACT_APP_API}/weddings/submit-rsvp`, {
                guestId
            })

            console.log('RSVP submitted:', response.data)
            setGuestData(response.data.guest)
            setIsReadOnly(true)
            setSubmittingRSVP(false)
            alert('Thank you! Your RSVP has been submitted successfully!')

        } catch (error) {
            console.error('Error submitting RSVP:', error)
            setSubmittingRSVP(false)
            alert('There was an error submitting your RSVP. Please try again.')
        }
    }

    const handleConfirmDecline = () => {
        setCanAttend(false)

        // Update RSVP response on the backend
        axios.post(`${process.env.REACT_APP_API}/weddings/update-rsvp-response`, {
            guestId,
            response: 'Decline'
        })
            .then((res) => {
                console.log('Guest declined invitation:', res.data)
            })
            .catch((error) => {
                console.error('Error updating RSVP response:', error)
            })

        // Scroll to decline container after modal closes
        setTimeout(() => {
            const declineContainer = document.getElementById('decline-container')
            if (declineContainer) {
                declineContainer.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }, 100)
    }

    const handlePlusOneChange = (index, field, value) => {
        setPlusOnesData(prevData => {
            const newData = [...prevData]
            newData[index] = { ...newData[index], [field]: value }
            return newData
        })
    }

    const handleSavePlusOnes = () => {
        setSavingPlusOnes(true)

        const convertToMealId = (val) => {
            if (!val || val === "") return "";
            if (val === "Skip this course") return "Skip this course";
            const allMeals = weddingData?.meals || [];
            const foundMeal = allMeals.find(meal => meal.name === val);
            return foundMeal ? foundMeal._id.toString() : val;
        };

        axios.patch(`${process.env.REACT_APP_API}/weddings/update-plus-ones`, {
            guestId,
            plusOnes: plusOnesData.map(plusOne => {
                const base = {
                    name: plusOne.name,
                    age: plusOne.age,
                    needsHighChair: plusOne.needsHighChair || false,
                };

                if (!requiresMealChoices) {
                    return base;
                }

                return {
                    ...base,
                    mealChoices: {
                        starter: convertToMealId(plusOne.starter),
                        main: convertToMealId(plusOne.main),
                        dessert: convertToMealId(plusOne.dessert)
                    },
                    dietaryRequirements: plusOne.dietaryRequirements,
                    noMealNeeded: plusOne.noMealNeeded || false,
                };
            })
        })
            .then((res) => {
                console.log('Plus ones saved:', res.data)
                setGuestData(res.data.guest)
                setSavingPlusOnes(false)
                alert('Plus one details have been saved successfully!')
            })
            .catch((error) => {
                console.error('Error saving plus ones:', error)
                setSavingPlusOnes(false)
                alert('There was an error saving plus one details. Please try again.')
            })
    }

    const handleOTPSubmit = (otp) => {
        setLoading(true)
        setOtpError('')

        axios.post(`${process.env.REACT_APP_API}/weddings/get-rsvp-by-id`, { guestId, otp })
            .then((res) => {
                setGuestData(res.data.guest)
                setWeddingData(res.data.wedding)
                setWeddingDate(res.data.wedding.weddingDate)
                setClientName(res.data.wedding.clientName)
                setSpouse(res.data.wedding.spouseName)
                setInvitedTo(res.data.guest.invitedTo)
                setGiftRegistryMsg(res.data.wedding.giftRegistry?.message || "Your presence is the greatest gift, but if you'd like to give something, a contribution to our honeymoon fund would mean the world!")

                // Check if guest has already responded and set canAttend state
                const guestResponse = res.data.guest.RSVP?.response;
                if (guestResponse === 'Accept') {
                    setCanAttend(true);
                } else if (guestResponse === 'Decline') {
                    setCanAttend(false);
                }

                // Check if RSVP is complete and set read-only state
                if (res.data.guest.RSVP?.complete === true) {
                    setIsReadOnly(true);
                }

                // Initialize form fields with guest data
                setGuestName(res.data.guest.name || "")
                setGuestEmail(res.data.guest.email || "")
                setGuestPhone(res.data.guest.number || "")
                setGuestDietary(res.data.guest.dietaryRequirements || "")

                // Normalize meal choices - keep meal IDs as IDs, handle both array and object formats
                const normalizeMealChoice = (val) => {
                    if (!val) return "";

                    // Handle "Skip this course" string - convert SKIP to "Skip this course"
                    if (val === "SKIP") return "Skip this course";
                    if (val === "Skip this course") return "Skip this course";

                    // Check if val is a meal name - convert to meal ID
                    const allMeals = res.data.wedding.meals || [];
                    const foundMeal = allMeals.find(meal => meal.name === val);

                    if (foundMeal) {
                        // It's a meal name, return the meal ID
                        return foundMeal._id.toString();
                    }

                    // Otherwise, assume it's already a meal ID and return as is
                    return val.toString();
                };

                // Handle legacy array format or new object format
                const mealChoices = res.data.guest.mealChoices;
                if (Array.isArray(mealChoices)) {
                    setGuestStarter(normalizeMealChoice(mealChoices[0] || ""))
                    setGuestMain(normalizeMealChoice(mealChoices[1] || ""))
                    setGuestDessert(normalizeMealChoice(mealChoices[2] || ""))
                } else {
                    setGuestStarter(normalizeMealChoice(mealChoices?.starter || ""))
                    setGuestMain(normalizeMealChoice(mealChoices?.main || ""))
                    setGuestDessert(normalizeMealChoice(mealChoices?.dessert || ""))
                }

                // Initialize plus ones data
                if (res.data.guest.plusOnes && res.data.guest.plusOnes.length > 0) {
                    const allMeals = res.data.wedding.meals || [];

                    const normalizeMealChoice = (val) => {
                        if (!val) return "";

                        // Handle "Skip this course" string - convert SKIP to "Skip this course"
                        if (val === "SKIP") return "Skip this course";
                        if (val === "Skip this course") return "Skip this course";

                        // Check if val is a meal name - convert to meal ID
                        const foundMeal = allMeals.find(meal => meal.name === val);

                        if (foundMeal) {
                            // It's a meal name, return the meal ID
                            return foundMeal._id.toString();
                        }

                        // Otherwise, assume it's already a meal ID and return as is
                        return val.toString();
                    };

                    setPlusOnesData(res.data.guest.plusOnes.map(plusOne => {
                        const poMealChoices = plusOne.mealChoices;
                        let starter = "", main = "", dessert = "";

                        if (Array.isArray(poMealChoices)) {
                            starter = normalizeMealChoice(poMealChoices[0] || "");
                            main = normalizeMealChoice(poMealChoices[1] || "");
                            dessert = normalizeMealChoice(poMealChoices[2] || "");
                        } else {
                            starter = normalizeMealChoice(poMealChoices?.starter || "");
                            main = normalizeMealChoice(poMealChoices?.main || "");
                            dessert = normalizeMealChoice(poMealChoices?.dessert || "");
                        }

                        return {
                            name: plusOne.name || "",
                            age: plusOne.age || "",
                            starter: starter,
                            main: main,
                            dessert: dessert,
                            dietaryRequirements: plusOne.dietaryRequirements || "",
                            noMealNeeded: plusOne.noMealNeeded || false,
                            needsHighChair: plusOne.needsHighChair || false
                        };
                    }))
                }

                // Close OTP modal on success
                setShowOTPModal(false)
                setLoading(false)
            })
            .catch((error) => {
                console.error('Error fetching RSVP data:', error)
                setLoading(false)

                if (error.response?.status === 401) {
                    setOtpError('Invalid passcode. Please try again.')
                } else if (error.response?.status === 403) {
                    // Subscription permission denied - redirect to home
                    console.log('No permission to access RSVP - subscription required')
                    navigate('/')
                } else {
                    setOtpError('An error occurred. Please try again.')
                }
            })
    }

    return (
        <>
            {showOTPModal && (
                <OTPModal
                    onSubmit={handleOTPSubmit}
                    error={otpError}
                />
            )}

            {showAcceptModal && (
                <AcceptModal
                    setOpen={setShowAcceptModal}
                    onConfirm={handleConfirmAccept}
                    guestName={guestData?.name}
                    showMealChoices={requiresMealChoices}
                />
            )}

            {showDeclineModal && (
                <DeclineModal
                    setOpen={setShowDeclineModal}
                    onConfirm={handleConfirmDecline}
                    guestName={guestData?.name}
                />
            )}

            <div className="rsvp-container" style={{ filter: showOTPModal ? 'blur(8px)' : 'none' }}>
                <div className="header">
                    <h1 id="you">YOU</h1>
                    <h2 id="are">are</h2>
                    <h1 id="invited">INVITED</h1>
                </div>

                <p style={{ marginTop: -95, fontSize: 20, marginBottom: 30 }}>to the {getInviteWording(invitedTo)} of</p>

                <div className="rsvp-names">
                    <p>{clientName ? clientName : ""} {clientName && spouse ? "&" : ""}</p>
                    <p>{spouse ? spouse : ""}</p>
                </div>

                <img
                    src={icon}
                    alt="Save the date icon"
                    className="icon"
                />

                <RsvpInvitationDetails
                    wedding={weddingData}
                    weddingDate={weddingDate}
                    invitedTo={invitedTo}
                    giftRegistryMsg={giftRegistryMsg}
                />

                <div>
                    <h2 className="rsvp-blue-header">rsvp</h2>
                    <p className='rsvp-subheader-black'>Can you join us for the big day?</p>

                    <div style={{ display: 'flex', gap: '15px', width: '100%', maxWidth: '500px', margin: '30px auto' }}>
                        <div
                            style={{
                                flex: 1,
                                backgroundColor: '#dde4f3',
                                borderRadius: '10px',
                                padding: '20px 15px',
                                cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-evenly',
                                gap: '10px',
                                opacity: isReadOnly ? 0.5 : 1
                            }}
                            onClick={handleAccept}
                        >
                            <img src={acceptIcon} alt="Accept" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
                            <p className="rsvp-btn-txt">Accept with pleasure</p>
                        </div>

                        <div
                            style={{
                                flex: 1,
                                backgroundColor: '#e8ecf4',
                                borderRadius: '10px',
                                padding: '20px 15px',
                                cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-evenly',
                                gap: '10px',
                                opacity: isReadOnly ? 0.5 : 1
                            }}
                            onClick={handleDecline}
                        >
                            <img src={declineIcon} alt="Decline" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
                            <p className="rsvp-btn-txt">Regretfully decline</p>
                        </div>
                    </div>

                    {isReadOnly && (
                        <p style={{
                            textAlign: 'center',
                            color: '#666',
                            fontSize: '14px',
                            fontStyle: 'italic',
                            maxWidth: '500px',
                            margin: '10px auto 20px'
                        }}>
                            Your response has been recorded. If you need to make any changes, please contact the couple directly.
                        </p>
                    )}

                    {weddingData?.RSVPReplyByDate &&
                        <>
                            <p className='rsvp-subheader-black'>Kindly reply by</p>
                            <p className='rsvp-subheader-black'>{moment(weddingData?.RSVPReplyByDate).format('Do MMMM YYYY')}</p>
                        </>

                    }
                </div>
                <div className="rsvp-line-break"></div>

                {canAttend &&
                    <>
                        <div id='accept-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="rsvp-flourish">
                                <img src={starsLeft} alt="" className="rsvp-flourish-left" />
                                <h2 className="rsvp-blue-header" style={{ color: '#323232' }}>Yay!</h2>
                                <img src={starsRight} alt="" className="rsvp-flourish-right" />
                            </div>

                            <p className='rsvp-subheader-black' style={{ marginTop: 20 }}>WE CAN’T WAIT TO <br /> CELEBRATE WITH YOU!</p>

                        </div>

                        <div className="rsvp-line-break"></div>

                        <div>
                            <h2 className="rsvp-blue-header">Your info</h2>
                            <p style={{ margin: "20px auto", textAlign: "center", width: "80%" }}>
                                {isReadOnly ? "Your confirmed details" : "Please confirm a few details so we can plan everything just right."}
                            </p>

                            <form>
                                <p style={{ fontWeight: 'bold' }}>Your Details</p>
                                <label>Your name</label>
                                <input
                                    type="text"
                                    value={guestName}
                                    onChange={(e) => setGuestName(e.target.value)}
                                    readOnly={isReadOnly}
                                />
                                <label>Your email</label>
                                <input
                                    type="email"
                                    value={guestEmail}
                                    onChange={(e) => setGuestEmail(e.target.value)}
                                    readOnly={isReadOnly}
                                />
                                <label>Your phone number</label>
                                <input
                                    type="tel"
                                    value={guestPhone}
                                    onChange={(e) => setGuestPhone(e.target.value)}
                                    readOnly={isReadOnly}
                                />

                                {!isReadOnly && (
                                    <button
                                        type="button"
                                        onClick={handleSaveGuestInfo}
                                        disabled={savingInfo}
                                        style={{
                                            width: '150px',
                                            padding: '10px 20px',
                                            marginTop: '20px',
                                            backgroundColor: '#4D8495',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '50px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: savingInfo ? 'not-allowed' : 'pointer',
                                            opacity: savingInfo ? 0.6 : 1,
                                            display: 'block',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        {savingInfo ? 'Saving...' : 'Save'}
                                    </button>
                                )}
                            </form>
                        </div>

                        {requiresMealChoices && (
                        <>
                        <div className="rsvp-line-break"></div>

                        <div>
                            <h2 className="rsvp-blue-header">Pick your meal</h2>
                            <p style={{ margin: "20px auto", textAlign: "center", width: "80%" }}>Let us know what you'd like to eat!</p>
                            <p style={{ fontWeight: 'bold' }}>Your Meal Selection</p>
                            <form>
                                <label>Starter</label>
                                <select
                                    value={guestStarter}
                                    onChange={(e) => setGuestStarter(e.target.value)}
                                    disabled={isReadOnly}
                                >
                                    <option value="">Please select a starter</option>
                                    {weddingData?.meals?.filter(meal => meal.course === 'Starter').map((meal, index) => (
                                        <option key={index} value={meal._id.toString()}>{meal.name}{getDietaryIdentifiers(meal)}</option>
                                    ))}
                                    <option value="Skip this course">Skip this course</option>
                                </select>

                                <label>Main</label>
                                <select
                                    value={guestMain}
                                    onChange={(e) => setGuestMain(e.target.value)}
                                    disabled={isReadOnly}
                                >
                                    <option value="">Please select a main course</option>
                                    {weddingData?.meals?.filter(meal => meal.course === 'Main').map((meal, index) => (
                                        <option key={index} value={meal._id.toString()}>{meal.name}{getDietaryIdentifiers(meal)}</option>
                                    ))}
                                    <option value="Skip this course">Skip this course</option>
                                </select>

                                <label>Dessert</label>
                                <select
                                    value={guestDessert}
                                    onChange={(e) => setGuestDessert(e.target.value)}
                                    disabled={isReadOnly}
                                >
                                    <option value="">Please select a dessert</option>
                                    {weddingData?.meals?.filter(meal => meal.course === 'Dessert').map((meal, index) => (
                                        <option key={index} value={meal._id.toString()}>{meal.name}{getDietaryIdentifiers(meal)}</option>
                                    ))}
                                    <option value="Skip this course">Skip this course</option>
                                </select>

                                <label>Dietary Requirements</label>
                                <textarea
                                    value={guestDietary}
                                    onChange={(e) => setGuestDietary(e.target.value)}
                                    rows={3}
                                    readOnly={isReadOnly}
                                />

                                {!isReadOnly && (
                                    <button
                                        type="button"
                                        onClick={handleSaveMealChoices}
                                        disabled={savingMeals}
                                        style={{
                                            width: '150px',
                                            padding: '10px 20px',
                                            marginTop: '20px',
                                            backgroundColor: '#4D8495',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '50px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: savingMeals ? 'not-allowed' : 'pointer',
                                            opacity: savingMeals ? 0.6 : 1,
                                            display: 'block',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        {savingMeals ? 'Saving...' : 'Save'}
                                    </button>
                                )}
                            </form>

                        </div>

                        <div className="rsvp-line-break"></div>
                        </>
                        )}

                        {!requiresMealChoices && plusOnesData && plusOnesData.length > 0 && (
                            <div className="rsvp-line-break"></div>
                        )}

                        {plusOnesData && plusOnesData.length > 0 && (
                            <>
                                <div id='plus-one-container'>
                                    <h2 className="rsvp-blue-header">Your plus {plusOnesData.length > 1 ? 'ones' : 'one'}</h2>
                                    <p style={{ margin: "20px auto", textAlign: "center", width: "80%" }}>
                                        {isReadOnly ?
                                            `Your confirmed guest${plusOnesData.length > 1 ? 's' : ''} details` :
                                            `You're welcome to bring ${plusOnesData.length} guest${plusOnesData.length > 1 ? 's' : ''} - we just need a few details to get everything ready!`
                                        }
                                    </p>

                                    {plusOnesData.map((plusOne, index) => (
                                        <div key={index} style={{ marginBottom: '40px' }}>
                                            {plusOnesData.length > 1 && (
                                                <p style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px', color: '#4D8495' }}>
                                                    Guest {index + 1}
                                                </p>
                                            )}

                                            <p style={{ fontWeight: 'bold' }}>Guest Details</p>
                                            <form>
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    value={plusOne.name}
                                                    onChange={(e) => handlePlusOneChange(index, 'name', e.target.value)}
                                                    readOnly={isReadOnly}
                                                />
                                                <label>Age</label>
                                                <div style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    marginTop: '10px',
                                                    marginBottom: '20px',
                                                    flexWrap: 'wrap'
                                                }}>
                                                    {['Adult', 'Child', 'Baby'].map((ageOption) => (
                                                        <button
                                                            key={ageOption}
                                                            type="button"
                                                            onClick={() => !isReadOnly && handlePlusOneChange(index, 'age', ageOption)}
                                                            disabled={isReadOnly}
                                                            style={{
                                                                flex: '1',
                                                                minWidth: '80px',
                                                                padding: '10px 20px',
                                                                borderRadius: '25px',
                                                                cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                                                transition: 'all 0.2s ease',
                                                                backgroundColor: plusOne.age === ageOption ? '#48688D' : 'white',
                                                                color: plusOne.age === ageOption ? 'white' : '#454C5C',
                                                                fontWeight: plusOne.age === ageOption ? 'bold' : 'normal',
                                                                border: plusOne.age === ageOption ? 'none' : '1px solid #B0ADAD',
                                                                opacity: isReadOnly ? 0.6 : 1
                                                            }}
                                                        >
                                                            {ageOption}
                                                        </button>
                                                    ))}
                                                </div>

                                                {plusOne.age === 'Baby' && (
                                                    <div style={{ marginTop: '10px', marginBottom: '20px' }}>
                                                        <p style={{ color: '#454C5C', marginBottom: '15px' }}>{requiresMealChoices ? 'Do you require either of the following?' : 'Do you require the following?'}</p>
                                                        {requiresMealChoices && (
                                                        <label style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginBottom: '15px',
                                                            cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                                            opacity: isReadOnly ? 0.6 : 1
                                                        }}>
                                                            <div
                                                                onClick={() => !isReadOnly && handlePlusOneChange(index, 'noMealNeeded', !plusOne.noMealNeeded)}
                                                                style={{
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '5px',
                                                                    marginRight: '12px',
                                                                    cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                                                    backgroundColor: plusOne.noMealNeeded ? '#48688D' : 'white',
                                                                    border: plusOne.noMealNeeded ? 'none' : '1px solid #B0ADAD',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    transition: 'all 0.2s ease',
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {plusOne.noMealNeeded && (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                            <span style={{ fontSize: '14px', color: '#454C5C' }}>No meal needed</span>
                                                        </label>
                                                        )}
                                                        <label style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                                            opacity: isReadOnly ? 0.6 : 1
                                                        }}>
                                                            <div
                                                                onClick={() => !isReadOnly && handlePlusOneChange(index, 'needsHighChair', !plusOne.needsHighChair)}
                                                                style={{
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '5px',
                                                                    marginRight: '12px',
                                                                    cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                                                    backgroundColor: plusOne.needsHighChair ? '#48688D' : 'white',
                                                                    border: plusOne.needsHighChair ? 'none' : '1px solid #B0ADAD',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    transition: 'all 0.2s ease',
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {plusOne.needsHighChair && (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                            <span style={{ fontSize: '14px', color: '#454C5C' }}>Please reserve a high chair</span>
                                                        </label>
                                                    </div>
                                                )}
                                            </form>

                                            {requiresMealChoices && !(plusOne.age === 'Baby' && plusOne.noMealNeeded) && (
                                                <>
                                                    <p style={{ fontWeight: 'bold', marginTop: '30px' }}>Meal Selection</p>
                                                    <p style={{ color: "#4D8495", margin: "20px 0" }}>Let us know what your guest would like to eat!</p>
                                                    <form>
                                                        <label>Starter</label>
                                                        <select
                                                            value={plusOne.starter}
                                                            onChange={(e) => handlePlusOneChange(index, 'starter', e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="">Please select a starter</option>
                                                            {weddingData?.meals?.filter(meal => meal.course === 'Starter').map((meal, mealIndex) => (
                                                                <option key={mealIndex} value={meal._id.toString()}>{meal.name}{getDietaryIdentifiers(meal)}</option>
                                                            ))}
                                                            <option value="Skip this course">Skip this course</option>
                                                        </select>

                                                        <label>Main</label>
                                                        <select
                                                            value={plusOne.main}
                                                            onChange={(e) => handlePlusOneChange(index, 'main', e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="">Please select a main course</option>
                                                            {weddingData?.meals?.filter(meal => meal.course === 'Main').map((meal, mealIndex) => (
                                                                <option key={mealIndex} value={meal._id.toString()}>{meal.name}{getDietaryIdentifiers(meal)}</option>
                                                            ))}
                                                            <option value="Skip this course">Skip this course</option>
                                                        </select>

                                                        <label>Dessert</label>
                                                        <select
                                                            value={plusOne.dessert}
                                                            onChange={(e) => handlePlusOneChange(index, 'dessert', e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="">Please select a dessert</option>
                                                            {weddingData?.meals?.filter(meal => meal.course === 'Dessert').map((meal, mealIndex) => (
                                                                <option key={mealIndex} value={meal._id.toString()}>{meal.name}{getDietaryIdentifiers(meal)}</option>
                                                            ))}
                                                            <option value="Skip this course">Skip this course</option>
                                                        </select>

                                                        <label>Dietary Requirements</label>
                                                        <textarea
                                                            value={plusOne.dietaryRequirements}
                                                            onChange={(e) => handlePlusOneChange(index, 'dietaryRequirements', e.target.value)}
                                                            rows={3}
                                                            readOnly={isReadOnly}
                                                        />
                                                    </form>
                                                </>
                                            )}
                                        </div>
                                    ))}

                                    {!isReadOnly && (
                                        <button
                                            type="button"
                                            onClick={handleSavePlusOnes}
                                            disabled={savingPlusOnes}
                                            style={{
                                                width: '150px',
                                                padding: '10px 20px',
                                                marginTop: '20px',
                                                backgroundColor: '#4D8495',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '50px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                cursor: savingPlusOnes ? 'not-allowed' : 'pointer',
                                                opacity: savingPlusOnes ? 0.6 : 1,
                                                display: 'block',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}
                                        >
                                            {savingPlusOnes ? 'Saving...' : 'Save'}
                                        </button>
                                    )}

                                </div>
                                <div className="rsvp-line-break"></div>
                            </>
                        )}

                    </>
                }

                {canAttend === false &&
                    <div id='decline-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div className="rsvp-flourish rsvp-flourish-miss">
                            <img src={heartsLeft} alt="" className="rsvp-flourish-left" />
                            <h2 className="rsvp-blue-header" style={{ color: '#323232' }}>You'll be<br /> missed!</h2>
                            <img src={heartsRight} alt="" className="rsvp-flourish-right" />
                        </div>

                        <p className='rsvp-subheader-black' style={{ marginTop: 20 }}>THANKS FOR YOUR RESPONSE — we'll MISS celebratING WITH YOU!</p>
                        <div className="rsvp-line-break"></div>

                    </div>
                }

                {canAttend === true && !isReadOnly && (
                    <button
                        type="button"
                        onClick={handleSubmitRSVP}
                        disabled={!canSubmit() || submittingRSVP}
                        style={{
                            width: '250px',
                            padding: '15px 30px',
                            marginTop: '40px',
                            marginBottom: '40px',
                            backgroundColor: canSubmit() ? '#4D8495' : '#cccccc',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: (!canSubmit() || submittingRSVP) ? 'not-allowed' : 'pointer',
                            opacity: submittingRSVP ? 0.6 : 1,
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        {submittingRSVP ? 'Submitting...' : 'Submit RSVP'}
                    </button>
                )}

                {isReadOnly && canAttend === true && (
                    <>
                        <div id='accept-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="rsvp-flourish">
                                <img src={starsLeft} alt="" className="rsvp-flourish-left" />
                                <h2 className="rsvp-blue-header" style={{ color: '#323232' }}>Thanks <br /> for your <br /> response!</h2>
                                <img src={starsRight} alt="" className="rsvp-flourish-right" />
                            </div>

                            <p className='rsvp-subheader-black' style={{ marginTop: 20 }}>We’re so excited to see you<br /> on the big day.</p>

                        </div>

                        <div className="rsvp-line-break"></div>


                    </>
                )
                }

                <WeddingWebsiteCallout friendlyURL={weddingData?.friendlyURL} />

                <a href='https://firstdance.app' target='_blank' style={{ textDecoration: 'unset' }}>
                    <p className='rsvp-subheader-black' >Sent With</p>
                    <img src={fdm} style={{ height: 100, width: 120, objectFit: 'contain' }} />
                </a>
            </div >
        </>
    )
}

export default RSVP